export default function WhatIs() {
  return (
    <section id="spreadsheet" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Czym jest Kakobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Kakobuy Spreadsheet to uporządkowana baza produktów pomagająca użytkownikom znaleźć najlepsze produkty, linki zakupowe, informacje QC oraz wskazówki dotyczące zakupów. Wszystko w jednym, łatwym w użyciu miejscu.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-4 px-4 text-sm font-semibold text-foreground-900">Funkcja</th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-primary-600">
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-primary-500"></i>
                    </div>
                    Kakobuy Spreadsheet
                  </div>
                </th>
                <th className="text-center py-4 px-4 text-sm font-semibold text-foreground-500">Standardowe wyszukiwanie</th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Gotowe produkty', kakobuy: 'Tak', standard: 'Nie' },
                { feature: 'Organizacja', kakobuy: 'Wysoka', standard: 'Niska' },
                { feature: 'QC informacje', kakobuy: 'Dostępne', standard: 'Brak' },
                { feature: 'Oszczędność czasu', kakobuy: 'Duża', standard: 'Mała' },
              ].map((row) => (
                <tr key={row.feature} className="border-b border-background-200/70 hover:bg-background-50/50 transition-colors">
                  <td className="py-3.5 px-4 text-sm text-foreground-700">{row.feature}</td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-primary-500"></i>
                      </div>
                      {row.kakobuy}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center text-sm text-foreground-400">{row.standard}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}